<template>
	<div>
		<v-layout wrap py-3 px-3>
			<v-flex xs12 mt-2>
				<label ref="label" for="download-excel">
					<vue-six-four
						ref="vueSixFour"
						id="download-excel"
						hidden
						@vue-six-four="getFile"
					/>
					<v-layout>
						<v-flex xs12 mr-2 pb-2 style="text-align: center;" >
							<v-btn
								color="success"
								class="btnLoadExcel white--text"
								href="https://maki-bucket1.s3.amazonaws.com/Maki_Contabilidad_exe/Centro+de+Costos.xlsx"
								download="plantilla_cuentas_contables.xlsx"
								@click="loader = 'loading3'"
							>
								Descargar Plantilla
							<v-icon right dark>file_download</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs12 class="container-import">
							<BaseInput
								:height="35"
								label="Adjuntar excel"
								v-model="excelName"
								required
								class="pr-4"
							>
								<span slot="error" class="caption error--text" v-if="!$v.model.base64.required">
									Es necesario cargar un archivo excel
								</span>
							</BaseInput>
							<button class="btn-import" @click="showDialog">
								<img src="/static/img/actions-list/excel.svg" alt="importar excel">
							</button>
						</v-flex>
					</v-layout>
				</label>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="$emit('on-close')"
				@accept-button-clicked="submitForm"
				:is-loading="disabled"
			/>
		</section>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseInput from '@/components/shared/inputs/base-input';
import BaseSelect from '@/components/shared/inputs/base-select';
import VueSixFour from 'vue-six-four';

function getFile(fileInfo) {
	this.excelName = fileInfo.name.replace(/\s/g, '-');
	const base64data = fileInfo.sixFour.split('base64,');
	this.model.base64 = base64data[1];
}

function showDialog() {
	this.$refs.label.click();
}

function disabled() {
	return this.$v.$invalid || this.loading;
}

function validations() {
	return {
		model: {
			base64: { required },
		},
	};
}

async function submitForm() {
	const words = this.excelName.split('.');
	const lastItem = words.length;
	const extension = words[lastItem - 1];
	const body = {
		subsidiaryId: Number(this.$route.query.subsidiaryId),
		base64: this.model.base64,
	};
	try {
		if (this.allowedFiles.indexOf(extension) > -1) {
			await this.$http.post('cost-center/import', body);
			this.showNotification('El archivo se ha cargado exitosamente', 'success');
			this.$emit('on-close');
		} else {
			this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`, 'warning');
		}
	} catch (err) {
		this.showGenericError();
	}
}

function data() {
	return {
		allowedFiles: ['xls', 'xlsx'],
		model: {
			base64: null,
		},
		newAccount: null,
		excelName: null,
	};
}

export default {
	name: 'cost-center-import',
	data,
	components: {
		BaseInput,
		BaseSelect,
		VueSixFour,
	},
	computed: {
		disabled,
	},
	methods: {
		getFile,
		showDialog,
		submitForm,
	},
	validations,
};
</script>
<style lang="scss" scoped>
	.container-import {
		position: relative;

		.btn-import {
			background: #03A89E;
			border-radius: 0 5px 5px 0;
			height: 35px;
			padding: 5px 7px 5px 0;
			position: absolute;
			right: 0;
			top: 16px;
			width: 51px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/cost-centers/cost-center-import.vue